var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 2400,
    height: 1365.170388892905,
    viewBox: "48.066483154296876 55.64165557861328 243.86703369140625 138.71668884277344",
    preserveAspectRatio: "xMidYMid meet",
    colorInterpolationFilters: "sRGB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 92,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fa71cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9b59b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 93,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f83600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 94,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0064d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1cb0f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 95,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f00978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3f51b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 96,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7873f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ec77ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 97,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e14fad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 98,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#009efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2af598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 99,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffcc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00b140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 100,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d51007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff8177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 102,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a2b6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c3483"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 103,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7ac5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#eea2a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 104,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ecbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#007adf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 105,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b88746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fdf5a6"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    className: "bordersvg b-d1",
    transform: "translate(51.67266762256622,58.032508850097656)"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 3,
    d: "M 123.93499755859375 33.81023025512695 A 66.96749877929688 66.96749877929688 0 1 0 123.93499755859375 100.1247673034668"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10,33.81023025512695)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 2,
    className: "i-icon-bg",
    x: 0,
    y: 0,
    width: 227.8699951171875,
    height: 66.31453704833984,
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10,3)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "",
    className: "tp-name"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.81-0.46L1.81-6.74Q14.54-6.04 19.05-6.04L19.05-6.04Q20.11-6.04 20.74-6.67 21.37-7.29 21.37-8.36L21.37-8.36 21.37-12.54 10.68-12.54Q5.81-12.54 3.6-14.75 1.39-16.95 1.39-21.83L1.39-21.83 1.39-23.23Q1.39-28.1 3.6-30.31 5.81-32.52 10.68-32.52L10.68-32.52 26.99-32.52 26.99-26.01 12.54-26.01Q9.75-26.01 9.75-23.23L9.75-23.23 9.75-22.3Q9.75-19.51 12.54-19.51L12.54-19.51 20.9-19.51Q25.46-19.51 27.59-17.37 29.73-15.24 29.73-10.68L29.73-10.68 29.73-8.36Q29.73-3.81 27.59-1.67 25.46 0.46 20.9 0.46L20.9 0.46Q18.53 0.46 15.89 0.37L15.89 0.37 11.61 0.19Q6.87-0.05 1.81-0.46L1.81-0.46ZM47.38-26.01L47.38 0 39.02 0 39.02-26.01 29.26-26.01 29.26-32.52 57.14-32.52 57.14-26.01 47.38-26.01ZM86.17-6.5L86.17 0 60.39 0 60.39-32.52 86.17-32.52 86.17-26.01 68.75-26.01 68.75-19.74 82.45-19.74 82.45-13.24 68.75-13.24 68.75-6.5 86.17-6.5ZM98.25-32.52L98.25-6.5 115.2-6.5 115.2 0 89.88 0 89.88-32.52 98.25-32.52ZM126.81-32.52L126.81-6.5 143.77-6.5 143.77 0 118.45 0 118.45-32.52 126.81-32.52ZM154.92-5.81L152.83 0 143.77 0 156.08-32.52 165.37-32.52 177.68 0 168.62 0 166.53-5.81 154.92-5.81ZM160.72-22.76L157.01-11.85 164.44-11.85 160.72-22.76ZM180 0L180-32.52 199.51-32.52Q204.39-32.52 206.59-30.31 208.8-28.1 208.8-23.23L208.8-23.23 208.8-19.05Q208.8-15.19 207.52-13.05 206.25-10.92 203.46-10.22L203.46-10.22 209.26 0 200.21 0 194.86-9.75 188.36-9.75 188.36 0 180 0ZM200.44-19.05L200.44-23.23Q200.44-26.01 197.65-26.01L197.65-26.01 188.36-26.01 188.36-16.26 197.65-16.26Q200.44-16.26 200.44-19.05L200.44-19.05Z",
    transform: "translate(-1.3899999856948853, 32.52000045776367)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    transform: "translate(0,35.980003356933594)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.9965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.41-4.82L13.41 0 1.03 0 1.03-4.82 4.13-4.82 4.13-19.26 1.03-19.26 1.03-24.08 13.41-24.08 13.41-19.26 10.32-19.26 10.32-4.82 13.41-4.82ZM37.14 0L37.14-13.41 32.33-4.82 27.51-4.82 22.7-13.41 22.7 0 16.51 0 16.51-24.08 23.04-24.08 29.92-11.35 36.8-24.08 43.34-24.08 43.34 0 37.14 0ZM47.46 0L47.46-24.08 61.91-24.08Q65.52-24.08 67.15-22.44 68.79-20.81 68.79-17.2L68.79-17.2 68.79-13.76Q68.79-10.15 67.15-8.51 65.52-6.88 61.91-6.88L61.91-6.88 53.65-6.88 53.65 0 47.46 0ZM62.6-13.76L62.6-17.2Q62.6-19.26 60.53-19.26L60.53-19.26 53.65-19.26 53.65-11.69 60.53-11.69Q62.6-11.69 62.6-13.76L62.6-13.76ZM90.97-4.82L90.97 0 71.88 0 71.88-24.08 90.97-24.08 90.97-19.26 78.07-19.26 78.07-14.62 88.22-14.62 88.22-9.8 78.07-9.8 78.07-4.82 90.97-4.82ZM93.72 0L93.72-24.08 108.17-24.08Q111.78-24.08 113.41-22.44 115.05-20.81 115.05-17.2L115.05-17.2 115.05-14.1Q115.05-11.25 114.1-9.66 113.15-8.08 111.09-7.57L111.09-7.57 115.39 0 108.68 0 104.73-7.22 99.91-7.22 99.91 0 93.72 0ZM108.85-14.1L108.85-17.2Q108.85-19.26 106.79-19.26L106.79-19.26 99.91-19.26 99.91-12.04 106.79-12.04Q108.85-12.04 108.85-14.1L108.85-14.1ZM129.83-4.82L129.83 0 117.45 0 117.45-4.82 120.55-4.82 120.55-19.26 117.45-19.26 117.45-24.08 129.83-24.08 129.83-19.26 126.74-19.26 126.74-4.82 129.83-4.82ZM148.41-6.53L148.41-24.08 154.6-24.08 154.6-6.53Q154.6-2.92 152.96-1.29 151.33 0.34 147.72 0.34L147.72 0.34 139.81 0.34Q136.2 0.34 134.56-1.29 132.93-2.92 132.93-6.53L132.93-6.53 132.93-24.08 139.12-24.08 139.12-6.53Q139.12-4.47 141.18-4.47L141.18-4.47 146.34-4.47Q148.41-4.47 148.41-6.53L148.41-6.53ZM179.36 0L179.36-13.41 174.55-4.82 169.73-4.82 164.92-13.41 164.92 0 158.72 0 158.72-24.08 165.26-24.08 172.14-11.35 179.02-24.08 185.55-24.08 185.55 0 179.36 0ZM188.96-0.34L188.96-4.99Q198.38-4.47 201.72-4.47L201.72-4.47Q202.51-4.47 202.97-4.94 203.44-5.4 203.44-6.19L203.44-6.19 203.44-9.29 195.53-9.29Q191.91-9.29 190.28-10.92 188.65-12.55 188.65-16.16L188.65-16.16 188.65-17.2Q188.65-20.81 190.28-22.44 191.91-24.08 195.53-24.08L195.53-24.08 207.6-24.08 207.6-19.26 196.9-19.26Q194.84-19.26 194.84-17.2L194.84-17.2 194.84-16.51Q194.84-14.45 196.9-14.45L196.9-14.45 203.09-14.45Q206.46-14.45 208.04-12.86 209.63-11.28 209.63-7.91L209.63-7.91 209.63-6.19Q209.63-2.82 208.04-1.24 206.46 0.34 203.09 0.34L203.09 0.34Q201.34 0.34 199.38 0.28L199.38 0.28 196.21 0.14Q192.7-0.03 188.96-0.34L188.96-0.34Z",
    transform: "translate(-1.0299999713897705, 24.079999923706055)"
  })))))))), /*#__PURE__*/React.createElement("defs", {
    "v-gra": "od"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTransparent);
export default __webpack_public_path__ + "static/media/logo_transparent.8cd652f647640795bf290dd9b40d61b7.svg";
export { ForwardRef as ReactComponent };